import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import ProjectCard from '../components/ProjectCard';
import { projects } from '../data/projects';
import './Projects.css';

const Products = () => (
  <>
    <title>Products - Pidesk</title>
    <meta name="description" content="College ERP software, a learning app, an online exam platform and more, built by Pidesk for colleges, coaching institutes and businesses." />

    <div className="page-shell">
      <div className="container">
        <div className="page-hero">
          <span className="projects-eyebrow">Products</span>
          <h1 className="page-title">Built by Pidesk</h1>
          <p className="page-subtitle">
            Platforms and tools we've designed and shipped. Open any product to see screenshots, features and details.
          </p>
        </div>

        <div className="projects-grid">
          {projects.map((p, idx) => <ProjectCard key={p.slug} project={p} index={idx} />)}
        </div>

        <div className="page-cta">
          <h2>Have a product in mind?</h2>
          <p>Tell us what you want to build and we'll take it from idea to launch.</p>
          <Link to="/contact" className="btn btn-primary btn-lg">
            Start a Project <ArrowRight size={18} style={{ marginLeft: 8 }} />
          </Link>
        </div>
      </div>
    </div>
  </>
);

export default Products;
